import { useState, useEffect, RefObject } from "react";

function useHover(
  ref: RefObject<HTMLElement>,
  onHover?: () => void,
  onFade?: () => void
): boolean {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  const hover = () => {
    if (onHover) {
      onHover();
    }
    setIsHovered(true);
  };

  const fade = () => {
    if (onFade) {
      onFade();
    }
    setIsHovered(false);
  };

  useEffect(() => {
    if (ref.current) {
      ref.current.addEventListener("mouseenter", hover);
      ref.current.addEventListener("mouseleave", fade);
    }

    return () => {
      if (ref.current) {
        ref.current.removeEventListener("mouseenter", hover);
        ref.current.removeEventListener("mouseleave", fade);
      }
    };
  }, []);

  return isHovered;
}

export default useHover;
